import React from 'react';
import { Container } from '@/components/layout/Container';
import { CtaButton } from '@/components/site/CtaButton';
import { CONSULTATION_PATH } from '@/lib/site';
import { useI18n } from '@/lib/i18n';

export default function NotFound() {
  const { t } = useI18n();

  return (
    <div
      className="flex min-h-[70vh] items-center py-20"
      style={{ backgroundColor: 'var(--rmh-canvas)' }}
      data-testid="not-found-page"
    >
      <Container className="text-center">
        <span
          className="rmh-num text-[0.8rem] tracking-[0.24em]"
          style={{ color: 'var(--rmh-muted-2)' }}
        >
          404
        </span>
        <h1 className="rmh-display mt-6 text-[2.2rem] sm:text-[3rem]">
          {t.notFound.title}
        </h1>
        <p className="rmh-body mx-auto mt-5 max-w-md text-[0.95rem]">{t.notFound.body}</p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <CtaButton
            to="/"
            size="lg"
            variant="primary"
            arrow
            testId="not-found-home-button"
          >
            {t.notFound.home}
          </CtaButton>
          <CtaButton
            to={CONSULTATION_PATH}
            size="lg"
            variant="secondary"
            testId="not-found-contact-button"
          >
            {t.common.bookConsultation}
          </CtaButton>
        </div>
      </Container>
    </div>
  );
}
